export function firstValidationError(errors) {
  if (!errors || typeof errors !== 'object') return ''
  for (const key of Object.keys(errors)) {
    const val = errors[key]
    if (Array.isArray(val) && val[0]) return String(val[0]).trim()
    if (typeof val === 'string' && val.trim()) return val.trim()
  }
  return ''
}

/** Axios body, interceptor `error.response`, or the JSON payload itself. */
export function apiErrorPayload(input) {
  if (!input || typeof input !== 'object') return {}
  const nested = input.data
  if (nested && typeof nested === 'object' && (nested.code != null || nested.status != null || nested.message != null || nested.metric != null)) {
    return nested
  }
  return input
}

export function parseEntitlementLimitError(input) {
  const data = apiErrorPayload(input)
  if (data.code !== 'entitlement_limit') return null
  return {
    code: 'entitlement_limit',
    metric: data.metric || null,
    limit: data.limit ?? null,
    usage: data.usage ?? null,
    attemptedUsage: data.attempted_usage ?? null,
    remaining: data.remaining ?? null,
    upgradeRequired: data.upgrade_required === true,
    message: typeof data.message === 'string' ? data.message : '',
  }
}

const ENTITLEMENT_METRIC_LABELS = {
  warehouses: { id: 'subscription_metric_warehouses', defaultMessage: 'Warehouses' },
  locations: { id: 'subscription_metric_warehouses', defaultMessage: 'Warehouses' },
  users: { id: 'users', defaultMessage: 'Users' },
  products: { id: 'products', defaultMessage: 'Products' },
}

export function formatEntitlementLimitMessage(input, trans) {
  const limit = parseEntitlementLimitError(input)
  if (!limit) return null
  const labelDef = ENTITLEMENT_METRIC_LABELS[limit.metric] || { id: limit.metric, defaultMessage: limit.metric || 'this limit' }
  const metricLabel = trans ? trans(labelDef) : labelDef.defaultMessage
  if (trans) {
    return trans(
      {
        id: 'subscription_entitlement_limit',
        defaultMessage: 'Your plan allows {limit} {metric}. Upgrade to add more.',
      },
      { limit: limit.limit ?? '—', metric: metricLabel },
    )
  }
  if (limit.limit != null) return `Your plan allows ${limit.limit} ${metricLabel}. Upgrade to add more.`
  return limit.message || 'Limit reached, please upgrade your package'
}

export function resolveApiErrorMessage(data = {}, trans) {
  const fromLimit = formatEntitlementLimitMessage(data, trans)
  if (fromLimit) return fromLimit

  const fromErrors = firstValidationError(apiErrorPayload(data).errors || data.errors)
  if (fromErrors) return fromErrors

  const payload = apiErrorPayload(data)
  if (typeof payload.message === 'string' && payload.message.trim()) {
    return payload.message.trim()
  }

  const code = payload.code || payload.error
  if (code === 'email_already_in_use' && trans) {
    return trans({
      id: 'company_admin_email_in_use',
      defaultMessage: 'The admin email is already in use by another account.',
    })
  }

  if (trans) {
    return trans({ id: 'an_error_occurred', defaultMessage: 'An error occurred' })
  }

  return 'An error occurred'
}

